<style scoped lang="less">
  .nameWrapper {
    display: flex;
    align-items: center;

    .name {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 600;
    }
  }
</style>
<template>
  <div class="nameWrapper" style="margin-bottom: 20px;">
    <span class="name">    <slot></slot></span>
    <div class="iconWrapperBox" style="margin-left: 20px;margin-top: 10px;">
      <img :src="doweImageIcon" alt="" style="width: 30px;height: 30px;"/>
    </div>
  </div>
</template>
<script>
  import doweImageIcon from '@wenxing/assets/images/d2.png'

  export default {
    data() {
      return {
        doweImageIcon
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/wenxing/components/indexTitle2.vue